<template>
  <div class="new_product_release_div">
    <menu-list v-if="!searching" :menuDataList="menuDataList" :menuShow="menuShow" @menuSwitch="menuSwitch" @handleMenuItemClick="handleMenuItemClick"></menu-list>
    <div :class="menuShow ? 'right_content' : 'right_content content_all'">
      <div>
        <div v-if="tagList.length || key" class="right_search_div">
          <span>全部结果：</span>
          <div class="right_search_input">
            <div v-for="(item, index) in tagList" :key="index" class="right_search_input_info">
              <div class="right_search_input_tag">
                <strong>{{getTagName(item)}}:{{item.name}}</strong>
                <b @click="deleteTag(item)">x</b>
              </div>
              <span> &gt; </span>
            </div>
          </div>
          <span v-if="key" class="right_search_key">"{{key}}"<b @click="deleteSearchText">x</b></span>
        </div>
        <goods-search v-if="queryData.length" :queryData="queryData" @softItemHandleClick="handleClickSoftItem" @handleClickProductItem="handleClickProductItem" @handleClickIndustryItem="handleClickIndustryItem"></goods-search>
      </div>
      <div class="brand_div">
        <goods-list :pdfList="pdfList" @PDFHandleClick="PDFHandleClick"></goods-list>
        <div class="clear_both"></div>
        <paging v-if="total > 10" :total="total" @handleCurrentChange="handleCurrentChange"></paging>
      </div>
      <canvas id="mxcad"></canvas>
    </div>
  </div>
</template>
<script>
import { baseUrl } from '../../utils';
// import Mx from 'mxdraw'
import { GetCanvasList } from '../../api/canvas/api'
import { GetCategoryList } from '../../api/home/api'
import menuList from '../public/menu.vue'
import goodsSearch from '../public/goodsSearch.vue'
import goodsList from '../public/goodsList.vue'
import paging from '../public/paging.vue'
export default {
  name: 'Blueprint2D3D',
  data() {
    return {
      cadFile: 'https://andrnd.com/files/20230512085754_1.dwg',
      searchList: {

      },
      fieldType: {
        brandType: '品牌',
        softType: '功能',
        productType: '产品',
        industryType: '工业'
      },
			baseUrl,
      // 是否展示菜单
      menuShow: true,
      // 菜单列表
      menuDataList: [],
      // 产品总条数
      total: 0,
      // 产品列表
      pdfList: [],
      // 当前页数
      currentPage: 1,
      // 每页条数
      pageSize: 10,
      // brand 品牌筛选
      brandId: 0,
      // 软件
      softId: 0,
      // 三级条件
      thirdCatId: 0,
      fourCatId: 0,
      // 产品分类
      productType: 0,
      subCatId: 0,
      // 产业分类
      industryType: 0,
      // 搜索文字
      key: '',
      // 筛选条件
      queryData: [],
      // 是否有搜索条件
      searching: false,
      // 条件列表
      tagList: [],
      itemId: 0,
      itemName: 0,
      industryFirstCatId: 0,
      industrySecordCatId: 0
    }
  },
  watch: {
    searching: {
      handler(val) {
        console.log(val, '变了')
      }
    },
    '$route.query.searchKey'(val){
      this.currentPage = 1;
      this.key = val || '';
      this.searching = true;
      this.getCanvasList();
    },
  },
  components: {
    menuList,
    goodsSearch,
    goodsList,
    paging
  },
  methods: {
    loadCADFile() {
      // Mx.loadCoreCode().then(()=> {
      //   Mx.MxFun.createMxObject({
      //     canvasId: 'mxcad',
      //     cadFile: 'http://af.andrnd.com/files/20230512085754_1.dwg',
      //     callback: (mxDraw, {
      //       canvas,
      //       canvasParent
      //     }) => {
      //       console.log('canvas', canvas, canvasParent)
      //       console.log('mxDraw', mxDraw)
      //       mxDraw.addEvent('uiSetLayerData', (listLayer) => {
      //         console.log('listLayer', listLayer)
      //       })
      //     },
      //     isNewFile: true
      //   })
      // })
    },
    getTagName(item) {
      return this.fieldType[item.fieldType];
    },
    initValue(type = 'all', fieldName) {
      this.currentPage = 1;
      if(type === 'all') {
        this.brandId = 0;
        this.softId = 0;
        this.subCatId = 0;
        this.thirdCatId = 0;
        this.fourCatId = 0;
        this.industryFirstCatId = 0;
        this.industrySecordCatId = 0;
        // this.key = '';
      } else if(type === 'brandType') {
        this.brandId = 0;
      } else if(type === 'softType') {
        this.softId = 0;
      } else if(type === 'productType') {
        if(fieldName === 'subCatId') {
          this.subCatId = 0;
          this.thirdCatId = 0;
        } else if(fieldName === 'thirdCatId') {
          this.thirdCatId = 0;
        }
        this.fourCatId = 0;
      } else if(type === 'industryType') {
        if(fieldName === 'industryFirstCatId') {
          this.industryFirstCatId = 0;
        }
        this.industrySecordCatId = 0;
      }
    },
    deleteSearchText() {
      this.key = '';
      this.searching = false;
      this.getCanvasList();
    },
    deleteTagList(item) {
      let tagList = this.tagList.filter(tag => {
        let {fieldType: type, fieldName, level} = item;
        if(type === 'brandType') {
          return tag.fieldType !== type;
          // return tag.level !== level;
        } else if(type === 'softType') {
          return tag.fieldType !== type;
        }
        else if(type === 'productType') {
          if(fieldName === 'subCatId') {
            return tag.fieldType !== type;
          } else if(fieldName === 'thirdCatId') {
            return tag.level !== level && tag.level !== 4;
          }
          return tag.level !== level;
        } else if(type === 'industryType') {
          if(fieldName === 'industryFirstCatId') {
            return tag.fieldType !== type;
          }
          return tag.level !== level;
        }
      });
      this.tagList = [...tagList];
    },
    deleteTag(item) {
      this.deleteTagList(item);
      this.initValue(item.fieldType, item.fieldName);
      this.tagList.forEach(item => this[item.key] = item.value);
      this.getCanvasList();
    },
    handleCurrentChange(value) {
      this.currentPage = value;
      this.getCanvasList();
    },
    menuSwitch(b) {
      this.menuShow = b;
    },
    handleMenuItemClick(item) {
      this.tagList = [];
      this.initValue();
      this.pushTagList({
        level: 1,
        key: 'thirdCatId',
        name: item.name,
        value: item.id,
        fieldType: 'productType'
      });
      this.thirdCatId = item.id;
      this.getCanvasList();
    },
    getCategoryList() {
      GetCategoryList().then(data => {
        data.forEach((item, index) => {
          item.index = index + '';
          if(item.categroyList && item.categroyList.length) {
            item.categroyList.forEach((childItem, childIndex) => {
              childItem.index = index + '-' + childIndex;
              if(childItem.categroyList && item.categroyList.length) {
                childItem.categroyList.forEach((childSubItem, childSubIndex) => {
                  childSubItem.index = index + '-' + childIndex + '-' + childSubIndex;
                });
              }
            });
          }
        });
        this.menuDataList = [...data];
      })
    },
		getCanvasList() {
			GetCanvasList({
				'brandId': this.brandId,
        'softId': this.softId,
				'industryFirstCatId': this.industryFirstCatId,
				'industrySecordCatId': this.industrySecordCatId,
				'thirdCatId': this.thirdCatId,
				'fourCatId': this.fourCatId,
        'subCatId': this.subCatId,
				'key': this.key,
				'pageNum': this.currentPage,
				'pageSize': this.pageSize
			}).then(data => {
				this.pdfList = [...data.list];
        this.total = data.total;
        data.queryData.forEach(item => {
          let {data, name, type} = item;
          data.length && data.forEach(dataItem => {
            dataItem.fieldName = name;
            dataItem.fieldType = type;
          })
        });
        this.queryData = [...data.queryData];
			})
		},
    pushTagList(item) {
      let tagList = [...this.tagList];
      tagList = tagList.filter(tag => (tag.level !== item.level));
      tagList.push(item);
      this[item.fieldName] = item.value;
      this.$nextTick(() => {
        tagList.sort((a, b) => {
          return a.level - b.level;
        });
        this.tagList = [...tagList];
      });
    },
    brandItemHandleClick(item) {
      item.key = 'brandId';
      item.level = 1;
      this.pushTagList(item);
      this.getCanvasList();
      this.initPage();
    },
    handleClickSoftItem(item) {
      item.key = 'softId';
      item.level = 1;
      this.pushTagList(item);
      this.getCanvasList();
      this.initPage();
    },
    initPage() {
      if(this.menuShow) {
        this.pageSize = 20;
      } else {
        this.pageSize = 24;
      }
      this.currentPage = 1;
    },
    handleClickProductItem(item) {
      item.key = 'productType';
      item.level = 2;
      if(item.fieldName === 'subCatId') {
        item.level = 2;
      } else if(item.fieldName === 'thirdCatId') {
        item.level = 3;
      } else if(item.fieldName === 'fourCatId') {
        item.level = 4;
      }
      this.pushTagList(item);
      this.getCanvasList();
      this.initPage();
    },
    PDFHandleClick(item) {
      window.open(window.location.origin + '#/Canvas/CanvasDetail?uuid=' + item.uuid)
    },
    handleClickIndustryItem(item) {
      item.key = 'industryType';
      item.level = 5;
      if(item.fieldName === 'industryFirstCatId') {
        item.level = 5;
      } else if(item.fieldName === 'industrySecordCatId') {
        item.level = 6;
      }
      this.pushTagList(item);
      this.getCanvasList();
      this.initPage();
    },
  },
  mounted() {
    let { searching, searchKey, itemId, itemName } = this.$route.query;
    this.searching = searching == 1 ? true : false;
    this.key = searchKey;
    if(itemId && itemName) {
      console.log('首页带参数到pdf首页 搜索态')
      this.pushTagList({
        level: 1,
        key: 'thirdCatId',
        name: itemName,
        fieldType: 'productType'
      });
      this.thirdCatId = itemId;
    } else if(searching == 1 && searchKey) {
      console.log('其他页搜索到pdf页')
      this.key = searchKey;
    } else {
      console.log('默认pdf')
    }
    this.getCategoryList();
		this.getCanvasList();
    window.addEventListener('setItemEvent', (e) => {
      if(e.key === 'searchKey') {
        this.key = e.newValue;
        this.getCanvasList();
      }
    });
    this.loadCADFile();
  },
  computed: {
  },
}
</script>
<style scoped>
@import '../../style/pdf.css'
</style>
